import { render, staticRenderFns } from "./MVPMediaDetailRenderer.vue?vue&type=template&id=0dd33ad2&scoped=true"
import script from "./MVPMediaDetailRenderer.vue?vue&type=script&lang=js"
export * from "./MVPMediaDetailRenderer.vue?vue&type=script&lang=js"
import style0 from "./MVPMediaDetailRenderer.vue?vue&type=style&index=0&id=0dd33ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd33ad2",
  null
  
)

export default component.exports